import { render, staticRenderFns } from "./titleBarBlock.vue?vue&type=template&id=0ec840e5&scoped=true"
import script from "./titleBarBlock.vue?vue&type=script&lang=js"
export * from "./titleBarBlock.vue?vue&type=script&lang=js"
import style0 from "./titleBarBlock.vue?vue&type=style&index=0&id=0ec840e5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec840e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ec840e5')) {
      api.createRecord('0ec840e5', component.options)
    } else {
      api.reload('0ec840e5', component.options)
    }
    module.hot.accept("./titleBarBlock.vue?vue&type=template&id=0ec840e5&scoped=true", function () {
      api.rerender('0ec840e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/titleBarBlock.vue"
export default component.exports